import { EventPageType } from '@graphql/generated';
import React, { useContext, useMemo } from 'react';
import { AlohaWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import { AuxFrame, AuxFrameContext } from '../AuxFrame';
import { HeaderPhoto } from './components/HeaderPhoto/HeaderPhoto';
import AuxFrameTitle from '../AuxFrame/components/AuxFrameTitle';
import { Box } from '@withjoy/joykit';

export const CustomizableHeader: React.FC<{
  eventHandle: string;
  websiteHeader: NonNullable<AlohaWebsiteHeaderSettings['websiteHeader']>;
  telemetryPhotoEditor: {
    onEditPhotoOpenedChange: (opened: boolean) => void;
  };
  fontColor?: string;
}> = ({ children, websiteHeader }) => {
  const { page, pages, pageSlug } = useContext(AuxFrameContext);
  const welcomePageId = useMemo(() => pages.find(page => page.type === EventPageType.welcome)?.id || '', [pages]);

  return (
    <AuxFrame>
      {websiteHeader && (
        <>
          <Box zIndex={100}>
            <AuxFrameTitle
              x={'left'}
              y={'bottom'}
              textLight={true}
              title={websiteHeader?.eventDisplayName}
              subtitle={websiteHeader?.greetingMessage}
              welcomePageId={welcomePageId}
              page={page}
              pageSlug={pageSlug || ''}
              zIndex={1}
            />
          </Box>
          <HeaderPhoto headerPhoto={websiteHeader?.headerPhoto} />
          {children}
        </>
      )}
    </AuxFrame>
  );
};
